import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Header } from '../Components/Header'
import { ShoppingCart as ShoppingCartIcon, MapPin, Clock, Award, Users, Shield, Wrench, CheckCircle } from 'lucide-react'
import { Button } from '../Components/ui/button'
import { ImageWithFallback } from '../Components/figma/ImageWithFallback'


export function AboutPage() {
  const [isCartOpen, setIsCartOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        cartItemCount={0} 
        onCartClick={() => setIsCartOpen(true)} 
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl mb-6">О Компании ИНТЕРШИНА</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
             «Интершина» – компания по продаже качественных зимних и летних шин, колесных дисков, автозапчастей, автомобильных масел и других расходных материалов для вашего автомобиля!
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl mb-6">О нас</h2>
              <p className="text-gray-700 mb-4">
               Наш торгово-сервисный центр оснащен современным высокотехнологичным оборудованием. Это позволяет нам выполнять полный комплекс работ, связанных с шинами и дисками, качественно и в кратчайшие сроки.

              </p>
              <p className="text-gray-700 mb-4">
                У вас установлены датчики давления в шинах? Для нас это не проблема! Все работы, связанные с программированием, клонированием и обслуживанием систем TPMS, – это к нам!
              </p>
              <p className="text-gray-700">
                В нашей комфортной зоне ожидания вы оцените преимущества персонального подхода именно к вам и вашему автомобилю. Мы предлагаем не сомнительную экономию на товарах с маркетплейсов, а уверенность в качестве и надежности.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-[#ed8510]">28+</div>
                <div className="text-gray-600">Лет на рынке автошин</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-[#ed8510]">1300+</div>
                <div className="text-gray-600">Клиентов хранят у нас шины</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-[#ed8510]">15+</div>
                <div className="text-gray-600">Премиум брендов</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-[#ed8510]">4.9★</div>
                <div className="text-gray-600">Рейтинг на Yandex картах</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl mb-4">Почему стоит нас выбирать?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
             Мы - больше, чем просто шиномонтажная мастерская. Мы - ваш партнер в области безопасности и эксплуатационных характеристик автомобилей.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ed8510] bg-opacity-10 rounded-full mb-4">
                <Award className="h-8 w-8 text-[#ed8510]" />
              </div>
              <h3 className="text-xl mb-3">Качество</h3>
              <p className="text-gray-600">        
                    Мы предлагаем шины только самого высокого качества от проверенных производителей, гарантирующие безопасность и эксплуатационные характеристики.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ed8510] bg-opacity-10 rounded-full mb-4">
                <Users className="h-8 w-8 text-[#ed8510]" />
              </div>
              <h3 className="text-xl mb-3">Команда профиссионалов</h3>
              <p className="text-gray-600">
                    Наши сертифицированные специалисты имеют многолетний опыт работы и постоянно проходят обучение по новейшим технологиям монтажа и ремонта шин.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ed8510] bg-opacity-10 rounded-full mb-4">
                <Shield className="h-8 w-8 text-[#ed8510]" />
              </div>
              <h3 className="text-xl mb-3">Гарантия соответствия цены</h3>
              <p className="text-gray-600">             
                    Мы стремимся обеспечить наилучшее соотношение цены и качества для ваших потребностей.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ed8510] bg-opacity-10 rounded-full mb-4">
                <Wrench className="h-8 w-8 text-[#ed8510]" />
              </div>
              <h3 className="text-xl mb-3">Полный комплекс услуг</h3>
              <p className="text-gray-600">
                    Мы предлагаем комплексные услуги по шиномонтажным работам в одном месте
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Physical Locations */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl mb-4">Посетите наш современный комплекс </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">              
                Ознакомьтесь с нашим выставочным залом и сервисной зоной , созданными для вашего удобства. Система предварительной  записи и электронной очереди, позволяет  минимизировать Ваше время ожидания для обслуживания в нашем центре
            </p>
          </div>

          {/* Main Exterior Image */}
          <div className="mb-8 rounded-xl overflow-hidden shadow-xl">
            <img 
              src="https://img.intershina.pro/images/about_3.jpg"
              alt="Сервис Интершина" 
              className="w-full h-[400px] object-cover"
            />
          </div>

          {/* Showroom Images Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://img.intershina.pro/images/about_1.jpg"
                alt="Шоурум Интершина" 
                className="w-full h-[350px] object-cover"
              />
              <div className="bg-white p-6">
                <h3 className="text-xl mb-2"></h3>
                <p className="text-gray-600">        
                        Ознакомьтесь с нашим ассортиментом в комфортной обстановке выставочного зала. Наш квалифицированный персонал всегда готов прийти Вам на помощь.
                </p>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://img.intershina.pro/images/about_2.jpg"
                alt="Интерьер Интершина" 
                className="w-full h-[350px] object-cover"
              />
              <div className="bg-white p-6">
                <h3 className="text-xl mb-2"> </h3>
                <p className="text-gray-600">            
                    
                </p>
              </div>
            </div>
          </div>

          {/* Location Details */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <MapPin className="h-8 w-8 text-[#ed8510] mb-4" />
              <h3 className="text-xl mb-3">Мы находимся</h3>
              <p className="text-gray-600 mb-2">ул. Карла Маркса, 63-65 </p>
              <p className="text-gray-600 mb-2">Гатчина</p>
              <p className="text-gray-600 mb-2">
                <a href="https://yandex.ru/profile/1068562381/?lang=ru&ll=30.130788%2C59.569869&no-distribution=1&source=wizbiz_new_map_single&view-state=mini&z=17&utm_source=share" className="inline-flex items-center" >
                  <img 
                    src="https://img.intershina.pro/images/yanavigator.png"
                    alt="Навигатор" 
                    className="object-cover" width="50"/> Мы на карте</a></p>
              <p className="text-[#ed8510]">+7(812)985-13-11</p>
              
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <Clock className="h-8 w-8 text-[#ed8510] mb-4" />
              <h3 className="text-xl mb-3">Часы работы</h3>
              <p className="text-gray-600 mb-1">Понедельник-Суббота: 09:00–19:00</p>
              <p className="text-gray-600">Воскресенье: 10:00–15:00</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <CheckCircle className="h-8 w-8 text-[#ed8510] mb-4" />
              <h3 className="text-xl mb-3">Наши услуги</h3>
              <p className="text-gray-600 mb-1">• Шиномонтаж легковых автомобилей</p>
              <p className="text-gray-600 mb-1">• Балансировка колёс</p>
              <p className="text-gray-600 mb-1">• Ремонт дисков</p>
              <p className="text-gray-600 mb-1">• Дошиповка шин</p>
              <p className="text-gray-600 mb-1">• Сезонное хранение колёс</p>
              <p className="text-gray-600">• Порошковая и акриловая покраска колёсных дисков</p>
            </div>
          </div>
        </div>
      </section>



      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg mb-4 text-[#ed8510]">ИНТЕРШИНА</h3>
              <p className="text-gray-400">Компания по продаже качественных зимних и летних шин, колесных дисков, автозапчастей, автомобильных масел и других расходных материалов для вашего автомобиля!</p>
            </div>
            <div>
              <h4 className="mb-4">Quick Links</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-[#ed8510] transition-colors">Начало</Link></li>
                <li><Link to="/#" className="hover:text-[#ed8510] transition-colors">О нас</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-4">Contact</h4>
              <div className="space-y-2 text-gray-400">
                <p className="hover:text-[#ed8510] transition-colors">+7(812)985-13-11</p>
                <p className="hover:text-[#ed8510] transition-colors">intershina@bk.ru</p>
                <p>ул. Карла Маркса, 63-65<br />Гатчина</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Интершина. При полном или частичном использовании материалов с сайта ссылка на источник обязательна.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}
